import { ReactNode } from "react";

import {
  StyledLiveBadge,
  StyledPreviewIntro,
  StyledPreviewTitle,
} from "./styled";

export function PreviewIntro({
  badge,
  title,
  children,
}: {
  badge: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <>
      <StyledLiveBadge>
        <i className="pi pi-eye" />
        {badge}
      </StyledLiveBadge>

      <StyledPreviewTitle>{title}</StyledPreviewTitle>

      <StyledPreviewIntro>{children}</StyledPreviewIntro>
    </>
  );
}
